import React, { useCallback, useEffect, useRef, useState } from "react";
import useQueryFilters from "../../hooks/useQueryFilters";
import galleryAPI from "../../api/galleryApi";

function List() {
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({});
  const [storage, setStorage] = useState({});
  const [loading, setLoading] = useState(false);

  const observer = useRef();

  /* =============  FETCH API DATA ================ */
  const { searchParams } = useQueryFilters();

  const fetchGalleryData = useCallback(
    async (page = 1, append = false) => {
      try {
        setLoading(true);

        const res = await galleryAPI.getDetails({
          ...searchParams,
          page,
          limit: 20,
        });

        console.log(res);

        if (res.code === 200) {
          const { items: newItems, pagination, storage } = res.data;

          setItems((prev) => (append ? [...prev, ...newItems] : newItems));

          setPagination(pagination);
          setStorage(storage);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    },
    [searchParams],
  );

  /* ============= INITIAL LOAD ================ */
  useEffect(() => {
    setItems([]);
    fetchGalleryData(1, false);
  }, [fetchGalleryData]);

  /* ============= INFINITE SCROLL ================ */
  const lastImageRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (
          entries[0].isIntersecting &&
          pagination.page < pagination.totalPages
        ) {
          const nextPage = pagination.page + 1;

          fetchGalleryData(nextPage, true);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, pagination, fetchGalleryData],
  );

  return (
    <div className="content">
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>Gallery</h4>
            <h6>Here all the image which you have uploaded</h6>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h4>Images ({storage?.totalMB?.toFixed(2)} MB)</h4>
        </div>

        <div className="card-body profile-body">
          <div className="row">
            {items?.map((item, index) => {
              const isLastItem = index === items.length - 1;

              return (
                <div
                  className="col-md-2 mb-3"
                  key={item._id}
                  ref={isLastItem ? lastImageRef : null}
                >
                  <div className="theme-type-images align-items-center mb-4">
                    <div className="theme-image border">
                      <div className="theme-image-set">
                        <img
                          src={item?.assetUrl}
                          alt={item?.title || "gallery"}
                          style={{
                            height: "120px",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <span>Size: {(item?.size / 1024).toFixed(2)} KB</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {loading && (
            <div className="text-center py-3">
              <p>Loading...</p>
            </div>
          )}

          {!loading && items?.length === 0 && (
            <div className="text-center py-5">
              <p>No Images Found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default List;
